import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import SplashScreen from './components/SplashScreen';
import ErrorBoundary from './components/ErrorBoundary';
import { AppProvider } from './context/AppContext';
import HomeView from './pages/public/HomeView';

// অন্যান্য পেজগুলো লেজি লোড করা হচ্ছে
const SearchView = React.lazy(() => import(/* webpackChunkName: "public-search" */ './pages/public/SearchView'));
const CategoriesView = React.lazy(() => import(/* webpackChunkName: "public-categories" */ './pages/public/CategoriesView'));

const OrdersView = React.lazy(() => import(/* webpackChunkName: "user-orders" */ './pages/user/OrdersView'));
const TrackOrderView = React.lazy(() => import(/* webpackChunkName: "user-track-order" */ './pages/user/TrackOrderView'));

const AdminPanelView = React.lazy(() => import(/* webpackChunkName: "admin-panel" */ './pages/admin/AdminPanelView'));

const App = () => {
  return (
    <ErrorBoundary>
      <AppProvider>
        <SplashScreen />
        <Router>
          <ErrorBoundary>
            <Suspense fallback={null}>
              <Routes>
                {/* পাবলিক জোন: যে কেউ দেখতে পারবে */}
                <Route path="/" element={<HomeView />} />
                <Route path="/home" element={<HomeView />} />
                <Route path="/search" element={<SearchView />} />
                <Route path="/categories" element={<CategoriesView />} />

                {/* ইউজার জোন: শুধুমাত্র ইউজারদের জন্য */}
                <Route 
                  path="/user/orders" 
                  element={
                    <ProtectedRoute allowedRole="user">
                      <OrdersView />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/orders" 
                  element={
                    <ProtectedRoute allowedRole="user">
                      <OrdersView />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/user/track" 
                  element={
                    <ProtectedRoute allowedRole="user">
                      <TrackOrderView />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/track" 
                  element={
                    <ProtectedRoute allowedRole="user">
                      <TrackOrderView />
                    </ProtectedRoute>
                  } 
                />

                {/* এডমিন জোন: শুধুমাত্র অ্যাডমিন ও এডিটরদের জন্য */}
                <Route 
                  path="/admin/*" 
                  element={
                    <ProtectedRoute allowedRole={['admin', 'editor', 'seller']}>
                      <AdminPanelView />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin" 
                  element={
                    <ProtectedRoute allowedRole={['admin', 'editor', 'seller']}>
                      <AdminPanelView />
                    </ProtectedRoute>
                  } 
                />

                {/* ক্যাচ-অল ফলব্যাক রুট */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Suspense>
          </ErrorBoundary>
        </Router>
      </AppProvider>
    </ErrorBoundary>
  );
};

export default App;
